import React from 'react';
import { Label, Table } from 'reactstrap';

import CurrencyFormat from '../../generic/CurrencyFormat';
import { changeRequestShape } from '../../prop-types';
import { getCampaignDiff } from '../utils';
import budgets from './budgets-deprecated';
import DeltaLabel from './DeltaLabel';

function ChangeBudgetComment({ changeRequest }) {
  const diffObject = getCampaignDiff(changeRequest);

  if (!diffObject) {
    return null;
  }

  const changedBudgets = budgets.filter(({ key }) =>
    // eslint-disable-next-line no-prototype-builtins
    diffObject.hasOwnProperty(key),
  );

  return (
    <Table striped size="sm" className="mb-2 small">
      <thead>
        <tr>
          <th className="border-top-0">Budget</th>
          <th className="border-top-0">Current</th>
          <th className="border-top-0">New</th>
          <th className="border-top-0">Delta</th>
        </tr>
      </thead>
      <tbody>
        {changedBudgets.map(({ name, key, newBudgetId = `ccr-${key}` }) => {
          const { draftValue, originValue } = diffObject[key];
          return (
            <tr key={key}>
              <td>
                <Label for={newBudgetId}>{name}</Label>
              </td>
              <td>
                <CurrencyFormat
                  value={originValue || 0}
                  className="text-nowrap"
                  text
                />
              </td>
              <td>
                <CurrencyFormat
                  value={draftValue || 0}
                  className="text-nowrap"
                  text
                />
              </td>
              <td>
                <DeltaLabel target={draftValue} current={originValue} />
              </td>
            </tr>
          );
        })}
      </tbody>
      <tfoot>
        <tr>
          <td className="border-top-2"> ∑ </td>
          <td className="border-top-2" />
          <td className="border-top-2" />
          <td className="border-top-2">
            <strong>
              <CurrencyFormat
                value={changedBudgets.reduce((delta, { key }) => {
                  const { draftValue, originValue } = diffObject[key];
                  return delta + (draftValue - originValue);
                }, 0)}
                className="text-nowrap"
                text
              />
            </strong>
          </td>
        </tr>
      </tfoot>
    </Table>
  );
}

ChangeBudgetComment.propTypes = {
  changeRequest: changeRequestShape.isRequired,
};

export default ChangeBudgetComment;
